const referente = {
    surname: '',
    name: '',
    email: '',
    phone: ''
};

export default referente
